// extracted by mini-css-extract-plugin
export default {"realEstateListFiltersWrapper":"real-estate-list-filters_realEstateListFiltersWrapper__EOrR1"};